import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/svg/calendar.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_3 from '../../assets/svg/clock.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "calendar"
}, null, -1)
const _hoisted_2 = {
  key: 1,
  class: "absolute right-0 mr-2 inset-y px-1 flex flex-row items-center content-center h-full"
}
const _hoisted_3 = {
  key: 0,
  src: _imports_1,
  class: `w-4`,
  alt: "up"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_2,
  class: `w-4`,
  alt: "down"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4 max-w-none",
  alt: "clock"
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "absolute right-0 mr-2 inset-y px-1 flex flex-row items-center content-center h-full"
}
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  class: `w-4`,
  alt: "up"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2,
  class: `w-4`,
  alt: "down"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createBlock("div", {
    class: `${_ctx.customClass} flex flex-row items-center relative`
  }, [
    (_ctx.showDatePicker)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["flex flex-row w-full", [{ 'border border-red-lp-1500 rounded': _ctx.isError }]]
        }, [
          (_ctx.showIcon)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                style: `height: ${_ctx.height}rem; margin-right: -1px;`,
                class: 
          `${_ctx.dateIconBackground} rounded-l-md text-black-lp-300 text-center border outline-none focus:shadow items-center py-2.5 text-12px xxl:text-14px px-3`
        
              }, [
                _hoisted_1
              ], 6))
            : _createCommentVNode("", true),
          _createVNode(_component_Calendar, {
            placeholder: _ctx.placeholder,
            modelValue: _ctx.setDefaultDate || _ctx.modelValue ? new Date(_ctx.modelValue) : '',
            onDateSelect: _ctx.onDateSelected,
            class: "w-full rounded-r-md font-montserrat",
            locale: _ctx.locale,
            inputStyle: 
          `${
            _ctx.disabled
              ? 'background: #f0f0f0 !important; opacity: 1 !important; cursor: not-allowed;'
              : ''
          }`
        ,
            style: `height: ${_ctx.height}rem`,
            minDate: _ctx.minDate,
            disabled: _ctx.disabled,
            manualInput: _ctx.manualInput,
            maxDate: _ctx.maxDate,
            yearNavigator: _ctx.yearNavigator,
            yearRange: _ctx.yearRange,
            disabledDays: _ctx.disabledDays,
            disabledDates: _ctx.disabledDates,
            dateFormat: _ctx.dateFormat,
            showButtonBar: _ctx.showButtonBar,
            onClearClick: _ctx.onClearDate,
            onMonthChange: _cache[1] || (_cache[1] = (e) => _ctx.$emit('month-change', e)),
            onYearChange: _cache[2] || (_cache[2] = (e) => _ctx.$emit('year-change', e)),
            onShow: _cache[3] || (_cache[3] = () => (_ctx.chevronUp = true)),
            onHide: _cache[4] || (_cache[4] = () => (_ctx.chevronUp = false))
          }, null, 8, ["placeholder", "modelValue", "onDateSelect", "locale", "inputStyle", "style", "minDate", "disabled", "manualInput", "maxDate", "yearNavigator", "yearRange", "disabledDays", "disabledDates", "dateFormat", "showButtonBar", "onClearClick"]),
          (!_ctx.disabled && _ctx.showChevron)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_ctx.chevronUp)
                  ? (_openBlock(), _createBlock("img", _hoisted_3))
                  : (_openBlock(), _createBlock("img", _hoisted_4))
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: 
        `flex flex-row items-center ${
          _ctx.showDatePicker ? 'ml-4' : ''
        } ${_ctx.customClassTime}`
      
    }, [
      (_ctx.showIcon)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: 
          `flex justify-center bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-r-0 ${
            _ctx.isError ? 'border-red-lp-1500' : 'border-gray-lp-400'
          } border outline-none focus:shadow py-1.8 px-2.5`
        ,
            style: {"height":"2.435rem","margin-right":"-1px"}
          }, [
            _hoisted_5
          ], 2))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_Calendar, {
        "model-value": _ctx.manualInput ? _ctx.timeValue : _ctx.modelValueTime,
        placeholder: _ctx.placeholder,
        onDateSelect: _ctx.onTimeSelected,
        onInput: _ctx.onInput,
        onBlur: _ctx.onBlur,
        disabled: _ctx.disabled,
        timeOnly: true,
        manualInput: _ctx.manualInput,
        style: `height: ${_ctx.height}rem`,
        onShow: _cache[5] || (_cache[5] = () => (_ctx.chevronUp = true)),
        onHide: _cache[6] || (_cache[6] = () => (_ctx.chevronUp = false)),
        inputStyle: _ctx.isError ? 'border: 1px solid #B82025;' : '',
        "panel-class": _ctx.manualInput ? 'hidden' : '',
        class: "w-full font-montserrat"
      }, null, 8, ["model-value", "placeholder", "onDateSelect", "onInput", "onBlur", "disabled", "manualInput", "style", "inputStyle", "panel-class"]), [
        [_vShow, _ctx.showTimePicker]
      ]),
      (!_ctx.disabled && _ctx.showChevron)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            (_ctx.chevronUp)
              ? (_openBlock(), _createBlock("img", _hoisted_7))
              : (_openBlock(), _createBlock("img", _hoisted_8))
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, _ctx.showTimePicker]
    ])
  ], 2))
}